module.exports = __webpack_public_path__ + "assets/img/ic_events_sm_light.c48545e6.svg";